// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"172":"648ba974","325":"16e14936","872":"40f7227e"}[chunkId] + ".css";
};